
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzButton from "@/models/MiezzButton";
import MiezzForm from "@/models/MiezzForm";
import MiezzModal from "@/models/MiezzModal";
import ParamCompanyCodeTypeAppService from "@/apis.machine/ParamCompanyCodeTypeAppService";
import DtoDetailParamCompanyCodeType, {
  DtoDetailParamCompanyCodeTypeMiezzDetailItems,
} from "@/models.machine/DtoDetailParamCompanyCodeType";
import ParamCompanyCodeTypeForm from "./ParamCompanyCodeTypeForm.vue";
import router from "@/router";

@Options({
  components: {
    ParamCompanyCodeTypeForm,
  },
})
export default class ParamCompanyCodeTypeDetail extends Vue {
  @Model() modelValue!: MiezzModal;
  @Prop() id?: string;

  detail = new MiezzForm<DtoDetailParamCompanyCodeType, string>(
    "System_ParamList_CompanyCodeType_Detail"
  );
  modalForm = new MiezzModal();

  /**创建时 */
  created(): void {
    //详细-数据-初始化
    this.detail.Data = new DtoDetailParamCompanyCodeType();
    //详细-元素配置
    this.detail.Items = DtoDetailParamCompanyCodeTypeMiezzDetailItems;
    for (const item of this.detail.Items) {
      switch (item.Prop) {
        case "ParamCountry":
          item.HandleFormat = () => {
            return `${this.detail.Data.ParamCountry?.NameZh}/${this.detail.Data.ParamCountry?.NameEn}`;
          };
          break;

        default:
          break;
      }
    }

    this.modelValue.HandleClick = this.handleClick;
    this.modelValue.Buttons = [
      {
        Code: "delete",
        Title: "删除",
        Icon: "delete",
        Type: "danger",
        Message: "是否确认删除",
        Size: "small",
        PowerCode: "System_ParamList_CompanyCodeType_Delete",
      },
    ];
    this.handleGet();
  }

  /**查询详细 */
  handleGet(): void {
    if (this.id) {
      ParamCompanyCodeTypeAppService.GetById(this.id).then((r) => {
        if (r.data.Data) this.detail.Data = r.data.Data;
      });
    }
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "delete":
        ParamCompanyCodeTypeAppService.Delete([this.id as string])
          .then(() => {
            this.handleDelete();
            complete();
          })
          .catch(complete);
        break;
      default:
        break;
    }
  }

  /**提交表单 */
  @Emit()
  handleSubmit(): void {
    this.modalForm.Show = false;
    this.handleGet();
  }

  /**删除 */
  @Emit()
  handleDelete(): void {
    //
  }
}
